var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var URLController = /** @class */ (function () {
    function URLController() {
    }
    /*****************************************************************************************************
        * Is using route "api/url" and http method "POST" to call the back-end.
    
        * @param {URLData} data
        * @returns {URLContent}
    ******************************************************************************************************/
    URLController.GetUrlInfo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/url", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    };
    return URLController;
}());
export { URLController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=URLController.js.map